// "Stuck? Talk to support" (support plan, 26 Oct). Offered by SupportCallRoot
// after two failed saves on one page (src/lib/helpNudge.ts). One tap opens the
// support panel and starts the call; X puts it away for half an hour.
import { Headset, X } from 'lucide-react'

export function HelpNudge({ onTalk, onDismiss }: { onTalk: () => void; onDismiss: () => void }) {
  return (
    <div role="status" aria-live="polite"
      className="print:hidden fixed left-4 bottom-[max(env(safe-area-inset-bottom),1rem)] above-bottom-nav-gap z-chrome flex items-center gap-1 rounded-full surface-sunk border hairline-strong shadow-xl pl-1 pr-1 py-1">
      <button type="button" onClick={onTalk}
        className="tap-target-y inline-flex items-center gap-2 rounded-full pl-2 pr-3 text-sm font-medium text-fg hover:bg-raised">
        <span className="inline-flex items-center justify-center rounded-full bg-emerald-500/15 text-emerald-400 p-1.5">
          <Headset size={16} aria-hidden="true" />
        </span>
        Stuck? Talk to support
      </button>
      <button type="button" onClick={onDismiss} aria-label="Not now"
        className="tap-target inline-flex items-center justify-center rounded-full text-fg-muted hover:text-fg">
        <X size={16} />
      </button>
    </div>
  )
}
